export default function ContactHero() {
  return (
    <section className="relative pt-24 pb-12 md:pt-32 md:pb-16">
      <div className="absolute inset-0 bg-gradient-to-b from-graphite-850 via-graphite-900 to-graphite-900" />
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-graphite-700 bg-graphite-800/50 mb-6">
            <span className="text-xs font-medium text-silver-300 tracking-wide">
              Get in Touch
            </span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Let's Talk <span className="text-emerald-accent">Business</span>
          </h1>
          <p className="text-base md:text-lg text-silver-300 max-w-3xl mx-auto leading-relaxed">
            Whether you are exploring our products, need a bespoke solution, or want to book a demo, we are here to help you move faster.
          </p>
        </div>
      </div>
    </section>
  );
}